import { render, staticRenderFns } from "./TableContacts.vue?vue&type=template&id=764b96e4&scoped=true&"
import script from "./TableContacts.vue?vue&type=script&lang=js&"
export * from "./TableContacts.vue?vue&type=script&lang=js&"
import style0 from "./TableContacts.vue?vue&type=style&index=0&id=764b96e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b96e4",
  null
  
)

export default component.exports